module.exports = __webpack_public_path__ + "img/blue_065.1c1211fb.png";